import { useEffect, useState } from 'react';
import { getCoverImageByCompanyId, CoverSize } from '@/utilities/coverImages';
import { CoverColumn, Cover, CoverFallback } from './styled';
interface Props {
  id: string;
  name: string;
  uniqueSymbol: string;
}

const CoverImage = (props: Props) => {
  const thumbnail = getCoverImageByCompanyId(
    props.id,
    CoverSize.DASHBOARD_THUMB
  );
  const ticker = String(props.uniqueSymbol).split(':')[1] || '';

  const [showFallback, setShowFallback] = useState<boolean>(false);

  //Reset on companyId change
  useEffect(() => {
    setShowFallback(false);
  }, [props.id]);

  const onImageError = () => {
    setShowFallback(true);
  };

  return (
    <CoverColumn>
      {showFallback ? (
        <CoverFallback>{ticker}</CoverFallback>
      ) : (
        <Cover
          src={thumbnail}
          alt={`${props.name} thumbnail`}
          onError={onImageError}
        />
      )}
    </CoverColumn>
  );
};

export default CoverImage;
